import { Tag } from '@/_models/Tag';
import { TNote } from './types';

export const pickTagThreadData = (tag: Tag): Partial<TNote> => {
  return {
    stemVectorX: tag.stemVectorX,
    stemVectorY: tag.stemVectorY,
    stemVectorZ: tag.stemVectorZ,
    defaultSid: tag.sid,
    tooltip: tag.tooltip,
    mpNavigation: tag.mpNavigation,
    positionX: tag.positionX,
    positionY: tag.positionY,
    positionZ: tag.positionZ,
  };
};
